<template>
    <div :class="relationsNetworkClassNames">
        <tooltipBlock
            v-if="showTooltip"
            :loading="tooltipLoading"
            :indexData="tooltipData"
            :closeToolTip="closeToolTip"
        />

        <relationsNetworkMenu
            v-if="nodes && nodes.length && showRelationsNetworkMenu"
            :downloadImage="downloadImage"
            :toggleFullScreen="toggleFullScreen"
            :printImage="printImage"
            :fullscreen="fullscreen"
            :resetDefault="resetDefault"
            :showRelationsAsList="showRelationsAsList"
            :toggleLegend="toggleLegend"
            :showLegend="showLegend"
        />

        <modal
            v-if="showAfilListModal"
            :close="() => { this.showAfilListModal = false }"
            :printButton="true"
            :downloadButton="true"
        >
            <div slot="modalHeader">{{printAndDownloadHeaderText}}</div>
            <modalBody slot="modalBody">
                <div v-if="relations && relations.length">
                    <p v-for="(e,i) in relations" :key="i">
                        <b>ЮЛ / ФЛ {{i+1}}:</b>
                        <span v-if="e && e.names && e.names.length && e.names[0].name">{{e.names[0].name}}</span>
                        <span v-if="e && e.inn">(ИНН: {{e.inn}})</span>
                    </p>
                </div>
                <afilModalListImg :src="canvasImgDataUrl()" alt="Связи Афил" />
                <afilModalListItem class="affiliantion-modal-list" v-for="(e,i) in afilAsList" :key="i" :style="{marginLeft: `${e.level ? 5 + (40 * (e.level-1)) : 5}px`, backgroundColor: i%2 ? '#dedede' : '#fff'}">
                    <afilModalListItemRow v-if="e.level" style="float: right">
                        <b>Уровень {{e.level}}</b>
                    </afilModalListItemRow>
                    
                    <afilModalListItemRow>
                        <span style="color: #aaa; font-weight: 500;">
                            {{i+1}}.
                        </span>
                        <a v-if="e.tooltipData && e.tooltipData.ogrn" :href="`/company/${e.tooltipData.ogrn}`" target="_blank">{{e.tooltipData.name_short ? e.tooltipData.name_short : e.tooltipData.name_full}}</a>
                        <person-afil style="display: inline-block" v-else-if="e.tooltipDat && e.tooltipData.inn" :inn="e.tooltipData.inn" :fio="e.tooltipData.title">{{e.tooltipData.title}}</person-afil>
                        <person-afil style="display: inline-block" v-else-if="e.label && e.inn" :inn="e.inn" :fio="e.label">{{e.label}}</person-afil>
                        <span v-else-if="e.tooltipData">{{e.tooltipData.name_short ? e.tooltipData.name_short : e.tooltipData.name_full}}</span>
                        <b v-else-if="e.label">{{e.label}}</b>
                    </afilModalListItemRow>

                    <afilModalListItemRow v-if="e.inn || e.ogrn">
                        <b v-if="e.inn">ИНН: </b>
                        <span v-if="e.inn">{{e.inn}}</span>
                        <b v-if="e.ogrn">ОГРН: </b>
                        <span v-if="e.ogrn">{{e.ogrn}}</span>
                    </afilModalListItemRow>

                    <afilModalListItemRow v-if="e.tooltipData && (e.tooltipData.date_start || e.tooltipData.date_stop)">
                        <span v-html="getStatusIcon(e.tooltipData.status_type)"></span>
                        <i style='padding-left: 2px; font-style: italic;'>
                            {{statusTypeText(e.tooltipData.status_type)}}
                            {{e.tooltipData.date_stop ? new Date(e.tooltipData.date_stop).toLocaleDateString('ru') : new Date(e.tooltipData.date_start).toLocaleDateString('ru')}}
                        </i>
                    </afilModalListItemRow>
                    
                    <afilModalListItemRow v-if="e.tooltipData && e.tooltipData.addr_full">
                        <b>Адрес: </b>
                        <span>{{e.tooltipData.addr_full}}</span>
                    </afilModalListItemRow>

                    <afilModalListItemRow v-if="e.tooltipData && e.tooltipData.upr && e.tooltipData.upr.length">
                        <b v-if="e.tooltipData.upr[0].position">{{lowerButFirst(e.tooltipData.upr[0].position)}}: </b>
                        <b v-else>Руководитель: </b>
                        <cardLink v-if="e.tooltipData.upr[0].ogrn" :ogrn="e.tooltipData.upr[0].ogrn">{{e.tooltipData.upr[0].name}}</cardLink>
                        <person-afil style="display: inline-block" v-else-if="e.tooltipData.upr[0].inn" :inn="e.tooltipData.upr[0].inn" :fio="e.tooltipData.upr[0].name">{{e.tooltipData.upr[0].name}}</person-afil>
                        <span v-else>{{e.tooltipData.upr[0].name}}</span>
                    </afilModalListItemRow>

                    <afilModalListItemRow v-if="e.tooltipData && e.tooltipData.uchr && e.tooltipData.uchr.length">
                        <b>Собственники: </b>
                        <span v-for="(uchrElm, uchrIndex) in e.tooltipData.uchr.filter((e,i) => i < 5)" :key="uchrIndex">
                            <a v-if="uchrElm.ogrn" :href="`/company/${uchrElm.ogrn}`" target="_blank">{{uchrElm.name}}</a>
                            <person-afil style="display: inline-block" v-else-if="uchrElm.inn" :inn="uchrElm.inn" :fio="uchrElm.name" />
                            <span v-else>{{uchrElm.name}}</span>
                            <span v-if="uchrIndex != e.tooltipData.uchr.filter((e,i) => i < 5).length - 1" style="margin-left: -2px;">, </span>
                        </span>
                    </afilModalListItemRow>

                    <afilModalListItemRow v-if="e.tooltipData && e.tooltipData.okved_title">
                        <b>ОКВЭД: </b>
                        {{e.tooltipData.okved_title}}
                    </afilModalListItemRow>

                    <afilModalListItemRow v-if="e.tooltipData && e.tooltipData.auth_capital">
                        <b>Уставный капитал: </b>
                        {{moneyFormat(e.tooltipData.auth_capital)}} руб.
                    </afilModalListItemRow>

                    <afilModalListItemRow v-if="e.tooltipData && e.tooltipData.fin_years && e.tooltipData.fin_rations && e.tooltipData.fin_rations.viruchka && e.tooltipData.fin_years.length">
                        <b>Выручка за {{e.tooltipData.fin_years[e.tooltipData.fin_years.length - 1]}} год:</b>
                        {{moneyFormat(e.tooltipData.fin_rations.viruchka)}} руб.
                    </afilModalListItemRow>
                </afilModalListItem>
            </modalBody>
        </modal>

        <div id="relations-search-scheme" ref="relations-search-scheme"></div>

        <relationsLegend
            :legend="legend"
            :toggleLegendRelations="toggleLegendRelations"
            :class="{fullscreen}"
            v-if="nodes && nodes.length && showLegend"
        />
    </div>
</template>

<script>
import axios from 'axios'
import styled from 'vue-styled-components'
import { base64StringToBlob } from 'blob-util'
import { htmlStringToPrint } from '@/helpers.ts'
import tooltipBlock from '@/components/ui/tooltip/tooltipBlock.vue'
import relationsNetworkMenu from '@/components/ui/relationsNetwork/relationsNetworkMenu.vue'
import relationsLegend from '@/components/ui/relationsNetwork/relationsLegend.vue'
import modal from '@/components/ui/modal.vue'
import cardLink from '@/components/ui/cardLink.vue'
import { set, get } from 'lodash'

const modalBody = styled.div`
    padding: 15px;
`
const afilModalListImg = styled.img`
    margin: 0 auto;
    display: block;
    width: 750px;
    border: 1px solid lightgray;
    border-radius: 5px;
`

const afilModalListItem = styled.ul`
    padding: 10px;
    font-size: 14px;
    border-radius: 5px;
    margin-bottom: 5px;
`

const afilModalListItemRow = styled.li`
    padding: 0;
    margin: 0;
`

const getIconColor = status => {
    switch(status) {
        case 2:
            return '#e85445'
        case 1:
            return '#2ecc71'
        case 3:
        case 4:
            return '#e7843c'
        default:
            return '#999'
    }
}

export default {
    props: {
        physics: Boolean,
        company: String || Number,
        relations: Array,
        showRelationsNetworkMenu: {
            type: Boolean,
            default: true
        },
        showLevelsInAfilAsList: {
            type: Boolean,
            default: false
        },
        printAndDownloadHeaderText: {
            type: String,
            default: 'Схема связей'
        }
    },
    components: {
        cardLink,
        afilModalListItemRow,
        afilModalListItem,
        afilModalListImg,
        relationsLegend,
        modalBody,
        tooltipBlock,
        modal,
        relationsNetworkMenu
    },
    data() {
        return {
            showAfilListModal: false,
            afilAsList: null,
            fullscreen: false,
            visData: null,
            nodes: null,
            defaultConnections: null,
            nodesToHide: [],
            edges: null,
            showTooltip: false,
            tooltipData: null,
            tooltipLoading: false,
            showLegend: false,
            legend: {
                nodes: {
                    1: true, // Юридическое лицо РФ
                    2: true, // Индивидуальный предприниматель
                    3: true, // Иностранное юридическое лицо
                    4: true, // субьект РФ
                    5: true // Физическое лицо
                },
                status: {
                    1: true, // действующее
                    2: true, // ликвидированно
                    3: true, // в стадии ликвидации
                    4: true // в стадии реорганизации
                },
                edges: {
                    3: true, // Руководитель
                    4: true, // Бывший рук
                    5: true, // Учредитель (Собственник) 
                    6: true, // Бывший Учредитель (Собственник)
                    7: true, // Залогодержатель
                    8: true, // Залогодержатель (бывший)
                    9: true, // Управляющий залогом
                    10: true, // Управляющий залогом (бывший)
                    11: true, // Доверительный управляющий
                    12: true, // Доверительный управляющий (бывший)
                    13: true, // Управляющий наследством
                    14: true, // Управляющий наследством (бывший)
                    15: true, // Лицо осуществляющее права
                    16: true, // Лицо осуществляющее права (бывший)
                    17: true, // Управляющий ПИФом
                    18: true, // Управляющий ПИФом (бывший)
                    19: true, // Управляющий товарищ
                    20: true, // Управляющий товарищ (бывший)
                    21: true // Предшественник
                }
            }
        }
    },
    methods: {
        toggleLegendRelations(params) {
            const legendsValueByParams = get(this.legend, params)
            set(this.legend, params, !legendsValueByParams)

            this.findAndHideRequsively(this.findAllHiddenNodesFromLegendStatus())
        },
        toggleLegend() {
            this.showLegend = !this.showLegend
        },
        resetDefault() {
            this.generateNewNetwork(this.defaultConnections)
        },
        canvasImgDataUrl() {
            return this.$refs['relations-search-scheme'].querySelector('.vis-network canvas').toDataURL()
        },
        showRelationsAsList() {
            const filteredHiddenNodes = Object.values(this.nodes?._data).filter(e => !e.hidden && (e.ogrn || e.inn))
            const listOfIdsOfAllNotHiddenNodes = filteredHiddenNodes.map(e => `&idlist[]=${e.ogrn || e.inn}`).join('')

            axios({
                method: 'get',
                url: `${process.env.API_PRO}/company/null/index?demo=1${listOfIdsOfAllNotHiddenNodes}`,
                params: {
                    idlist: this.$props.nodes
                },
                headers: {
                    Authorization: `Bearer ${window.apiSession}`
                }
            }).then(e => {
                this.afilAsList = filteredHiddenNodes.map(elm => ({
                    ...elm,
                    level: this.$props.showLevelsInAfilAsList ? elm.level : null,
                    tooltipData: e.data.data.find(singleTooltipElement => elm.inn == singleTooltipElement.inn || elm.ogrn == singleTooltipElement.ogrn)
                })).sort((a, b) => a.level - b.level)
                this.showAfilListModal = true
            })
        },
        downloadImage() {
            const filename = 'Poisk_svyazei'
            const affilBase64Img = $('.vis-network canvas')[0].toDataURL().replace(/data:image\/png;base64,/, '')
            const blob = base64StringToBlob(affilBase64Img, 'image/png')
            const link2Download = document.createElement('a')
            const fileURL = window.URL.createObjectURL(blob)
            link2Download.href = fileURL
            link2Download.download = filename
            document.body.appendChild(link2Download) 
            link2Download.click()
            link2Download.remove()
        },
        printImage() {
            let html = ''

            if(this.$props.relations?.length) {
                html += this.$props.relations?.length ? this.$props.relations.map((e, i) => {
                    return `<div><b>ЮЛ / ФЛ ${i+1}:</b> ${e?.names?.[0]?.name ?? ''} ${e?.inn ? `(ИНН ${e.inn})` : ''}</div>`
                }).join('') : ''
            }

            html += `<img src="${this.canvasImgDataUrl()}">`
            
            const htmlToPrint = htmlStringToPrint(this.$props.printAndDownloadHeaderText, html)

            const printWin = window.open()
            printWin.document.write(htmlToPrint)
            printWin.print()
            printWin.document.close()
        },
        toggleFullScreen() {
            this.fullscreen = !this.fullscreen
        },
        closeToolTip() {
            this.showTooltip = false
        },
        setNodeAsLoadingById(id) {
            const node = this.getNode(id)
            this.nodes.update([{ id: id, loading: true, label: `${node.label}...` }])
        },
        removeLoadingFromNodeById(id) {
            const node = this.getNode(id)
            this.nodes.update([{ id: id, loading: false, label: node.label.replace('...', '') }])
        },
        setNodeAsExpandedById(id) {
            this.nodes.update([{ id, expanded: true }])
        },
        getNode(id) {
            var result = false

            for(var i in this.nodes._data) {
                var node = this.nodes._data[i]
                if(node.id == id) {
                    result = node
                    break
                }
            }

            return result
        },
        getEdge(from, to) {
            var result = false
            for(var i in this.edges._data) {
                var edge = this.edges._data[i]
                if(edge.from == from && edge.to == to) {
                    result = edge
                    break
                }
                if(edge.to == from && edge.from == to) {
                    result = edge
                    break
                }
            }
            return result
        },
        getCompanyById(id, level = 1) {
            if(id) {
                this.setNodeAsLoadingById(id)
                axios({
                    method: 'post',
                    url: process.env.API_MS_AFFIL,
                    data: {
                        method: 'get',
                        auth: {
                            sid: window.apiSession
                        },
                        data: {
                            id,
                            limit: 50
                        }
                    }
                }).then(e => {
                    if(e.data.data?.nodes?.length) {
                        this.setNodeAsExpandedById(id)
                        this.renderCompany(e.data.data, level)
                    }
                }).catch(() => {
                    this.$store.dispatch('showErrorPopUp', 'Неизвестная ошибка')
                    this.nodes.update([{ id, loading: false, expanded: false, label: this.getNode(id).label.replace('...', '') }])
                }).finally(() => {
                    this.removeLoadingFromNodeById(id)
                })
            }
        },
        renderCompany(connections, level = 1) {

            if(connections?.nodes?.length) {
                for(const e of connections.nodes) {
                    if(!this.getNode(e.lic_id)) {
                        this.nodes.add({
                            id: e.lic_id,
                            inn: e.inn,
                            ogrn: e.ogrn,
                            label: e.title,
                            status: e.status,
                            group: e.type,
                            showAdjacentNodes: true,
                            level: level + 1,
                            font: {
                                size: e.style?.bold ? 14 : 10
                            },
                            icon: {
                                size: e.style?.bold ? 50 : 30,
                                color: getIconColor(e.status)
                            }
                        })
                    }
                }
            }

            if(connections?.links?.length) {
                for(const e of connections.links) {
                    if(!this.getEdge(e.src_lic_id, e.dst_lic_id)) {
                        this.edges.add({
                            from: e.src_lic_id,
                            to: e.dst_lic_id,
                            type: e.type,
                            dashes: this.getEdgeDashesByType(e.type),
                            color: this.getEdgeColorByType(e.type),
                            label: `${e.percent}\n${e.title}`,
                            font: { color: '#999' },
                            id: `${e.src_lic_id}_${e.dst_lic_id}`,
                            arrows: { to: { scaleFactor: 0.5 }}
                        })
                    }
                }
            }
        },
        getTooltipInfoAndRenderTooltip(nodeId) {
            const nodeOgrn = this.getNode(nodeId)?.ogrn
            this.showTooltip = true
            this.tooltipLoading = true
            this.tooltipData = null
            axios({
                url: `${process.env.API_PRO}/company/${nodeOgrn}/index`,
                headers: {
                    Authorization: `Bearer ${window.apiSession}`
                }
            }).then(e => {
                if(e.data?.data && JSON.stringify(e.data.data) != '{}') {
                    this.tooltipData = e.data?.data
                } else {
                    this.tooltipLoading = false
                    this.showTooltip = false
                }
            }).finally(() => {
                this.tooltipLoading = false
            })
        },
        async generateNewNetwork(connections) {         
            const htmlHandler = this.$refs['relations-search-scheme']

            this.defaultConnections = connections
            this.nodes = new vis.DataSet()
            this.edges = new vis.DataSet()

            const options = {
                interaction: {
                    hover: true
                },
                physics: {
                    enabled: this.$props.physics,
                    barnesHut: {
                        gravitationalConstant: -8308,
                        centralGravity: .5
                    },
                    maxVelocity: 10,
                    minVelocity: .5,
                    timestep: 1
                },
                nodes: {  shape: 'dot', size: 20, borderWidth: 0, font: { face: 'Monospace', size: 10, color: '#000000', strokeWidth: 3, strokeColor: '#ffffff'  }},
                edges: {  width: 1, color: '#cbc7cd', font: { face: 'Monospace', size: 10, color: '#000', strokeWidth: 3, strokeColor: '#ffffff' }},
                groups: {
                    1: { shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf1ad', color: '#999' }},
                    3: { shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf0ac', color: '#999' }},
                    5: { shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf183', color: '#999' }},
                    2: { shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf007', color: '#999' }},
                    4: { shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf19c', color: '#999' }}
                }
            }

            this.renderCompany(connections, 0)
            
            const network = new vis.Network(htmlHandler, { nodes: this.nodes, edges: this.edges }, options)

            network.on('click', e => {
                const clickedNode = this.getNode(e.nodes[0])

                if(!clickedNode.id) return
                if(clickedNode.loading) return
                // if(clickedNode.noclick) return

                if(clickedNode.expanded && clickedNode.ogrn) {
                    window.open(`/company/${clickedNode.ogrn}`, '_blank')
                } else if(clickedNode.id) {
                    this.getCompanyById(clickedNode.id, clickedNode.level)
                }
            })

            network.on('afterDrawing', ctx => {
                const allNodePositions = network.getPositions()
                const offsetMenuX = 28
                const offsetMenuY = 25
                const offsetTargetMenuX = 36
                const offsetTargetMenuY = 33
                const circleRadius = 8

                // NOTE функция отрисовки минуса закрытия на канвасе
                function drawHideNodesMenu(x, y) {
                    ctx.strokeStyle = '#999'
                    ctx.fillStyle = '#fff'
                    ctx.lineWidth = 1
                    ctx.beginPath()

                    ctx.arc(x + 24, y - 19, 7, 0, Math.PI * 2)
                    ctx.fill()
                    ctx.stroke()
                    
                    ctx.moveTo(x + 20, y - 19)
                    ctx.lineTo(x + 28, y - 19)
                    ctx.stroke()
                }

                // NOTE функция отрисовки плюса раскрытия на канвасе
                function drawShowNodesMenu(x, y) {
                    ctx.strokeStyle = '#999'
                    ctx.fillStyle = '#fff'
                    ctx.lineWidth = 1
                    ctx.beginPath()

                    ctx.arc(x + 24, y - 19, 7, 0, Math.PI * 2)
                    ctx.fill()
                    ctx.stroke()
                    
                    ctx.moveTo(x + 20, y - 19)
                    ctx.lineTo(x + 28, y - 19)
                    ctx.stroke()

                    ctx.moveTo(x + 24, y - 15)
                    ctx.lineTo(x + 24, y - 23)
                    ctx.stroke()
                }

                // NOTE функция отрисовки меню на канвасе
                function drawTooltipMenu(x, y) {
                    ctx.strokeStyle = '#999'
                    ctx.fillStyle = '#fff'
                    ctx.lineWidth = 2

                    ctx.beginPath()
                    ctx.moveTo(x - 4, y)

                    ctx.arc(x + 7, y + 2, 2, Math.PI * 1.5, 0)
                    ctx.arc(x + 6, y + 8, 2, 0, Math.PI / 2)
                    ctx.lineTo(x + 4, y + 10)
                    ctx.lineTo(x + 4, y + 13)
                    ctx.lineTo(x, y + 10)
                    ctx.arc(x - 5, y + 8, 2, Math.PI / 2, Math.PI )
                    ctx.arc(x - 6, y + 2, 2, Math.PI, Math.PI * 1.5)

                    ctx.closePath()
                    ctx.stroke()
                    ctx.fill()
                    
                    ctx.beginPath()
                    ctx.arc(x - 4, y + 5, 0.5, 0, Math.PI * 2)
                    ctx.stroke()

                    ctx.beginPath()
                    ctx.arc(x + 0.5, y + 5, 0.5, 0, Math.PI * 2)
                    ctx.stroke()

                    ctx.beginPath()
                    ctx.arc(x + 5, y + 5, 0.5, 0, Math.PI * 2)
                    ctx.stroke()
                }

                // NOTE перебираем все позиции нодов и рисуем меню в зависимости от их позиции
                for(const e in allNodePositions) {
                    const nodePosition = allNodePositions[e]
                    const node = this.getNode(e)
                    const fromINN = this.hintSuggestion?.from?.inn
                    const toINN = this.hintSuggestion?.to?.inn
                    const isTargetNode = node.inn === fromINN || node.inn === toINN
                    // NOTE отрисовка меню тултипа
                    if(nodePosition && node.ogrn) {
                        drawTooltipMenu(
                            nodePosition.x - (isTargetNode ? offsetTargetMenuX : offsetMenuX), 
                            nodePosition.y - (isTargetNode ? offsetTargetMenuY : offsetMenuY)
                        )
                    }

                    if(this.getNode(e).expanded) {
                        if(this.getNode(e).showAdjacentNodes) {
                            drawHideNodesMenu(nodePosition.x, nodePosition.y)
                        } else {
                            drawShowNodesMenu(nodePosition.x, nodePosition.y)
                        }
                    }
                }
                
                // NOTE "Клик по канвасу"
                const VUE_SELF = this
                $('#relations-search-scheme .vis-network canvas').off('click')
                $('#relations-search-scheme .vis-network canvas').click(function(event) {
                    var clickDOMPositionInsideCanvas = {
                        x: Math.floor(event.originalEvent.pageX - $(this).offset().left),
                        y: Math.floor(event.originalEvent.pageY - $(this).offset().top)
                    }

                    // если клик находится в пределах массива *allNodePositions*
                    for(var nodeId in allNodePositions) {
                        const node = VUE_SELF.getNode(nodeId)
                        const fromINN = VUE_SELF.hintSuggestion?.from?.inn
                        const toINN = VUE_SELF.hintSuggestion?.to?.inn
                        const isTargetNode = node.inn === fromINN || node.inn === toINN
                        const positions = {
                            canvasPositions: {
                                x: allNodePositions[nodeId].x,
                                y: allNodePositions[nodeId].y
                            },
                            get nodeDOMPositions() {
                                return {
                                    x: Math.floor(network.canvasToDOM(this.canvasPositions).x),
                                    y: Math.floor(network.canvasToDOM(this.canvasPositions).y)
                                }
                            },
                            get tooltipCircleCanvasPosition() {
                                return {
                                    x: this.canvasPositions.x - (isTargetNode ? offsetTargetMenuX : offsetMenuX),
                                    y: this.canvasPositions.y - (isTargetNode ? offsetTargetMenuY : offsetMenuY) + 5
                                }
                            },
                            get closeCircleCanvasPosition() {
                                return {
                                    x: this.canvasPositions.x + 24,
                                    y: this.canvasPositions.y - 19
                                }
                            },
                            get tooltipCircleDOMPosition() {
                                return {
                                    x: Math.floor(network.canvasToDOM(this.tooltipCircleCanvasPosition).x),
                                    y: Math.floor(network.canvasToDOM(this.tooltipCircleCanvasPosition).y)
                                }
                            },
                            get closeCircleDOMPosition() {
                                return {
                                    x: Math.floor(network.canvasToDOM(this.closeCircleCanvasPosition).x),
                                    y: Math.floor(network.canvasToDOM(this.closeCircleCanvasPosition).y)
                                }
                            },
                            get conditionals() {
                                var tooltip = this.tooltipCircleDOMPosition
                                var close = this.closeCircleDOMPosition
                                var cl = clickDOMPositionInsideCanvas
                                var rad = circleRadius

                                return {
                                    tooltip: cl.x >= (tooltip.x - rad) && cl.x <= (tooltip.x + rad) && cl.y >= (tooltip.y - rad) && cl.y <= (tooltip.y + rad),
                                    close: cl.x >= (close.x - rad) && cl.x <= (close.x + rad) && cl.y >= (close.y - rad) && cl.y <= (close.y + rad)
                                }
                            }
                        }

                        if(positions.conditionals.tooltip) {
                            VUE_SELF.getTooltipInfoAndRenderTooltip(nodeId)
                        }

                        // NOTE Обработка клика минуса/ плюса, закрытия / открытия нод
                        if(positions.conditionals.close) {
                            // если у ноды есть параметр showAdjacentNodes
                            if(VUE_SELF.getNode(parseInt(nodeId)).showAdjacentNodes) {
                                VUE_SELF.nodesToHide = Array.from(new Set([...VUE_SELF.nodesToHide, parseInt(nodeId)]))
                                VUE_SELF.nodes.update({ ...VUE_SELF.getNode(parseInt(nodeId)), showAdjacentNodes: false })
                                VUE_SELF.findAndHideRequsively(VUE_SELF.findAllHiddenNodesFromLegendStatus(), 5)
                            } else {
                                VUE_SELF.nodesToHide = VUE_SELF.nodesToHide.filter(e => e != parseInt(nodeId))
                                VUE_SELF.nodes.update({ ...VUE_SELF.getNode(parseInt(nodeId)), showAdjacentNodes: true })
                                VUE_SELF.findAndHideRequsively(VUE_SELF.findAllHiddenNodesFromLegendStatus(), 5)
                            }
                        }
                    }
                })
            })
        },
        // NOTE "Рекурсивный поиск нод"
        findAndHideRequsively(hiddenNodes = this.nodesToHide, recursionCounter = 5) {
            const edgesData = this.edges._data
            const nodesData = this.nodes._data

            let hiddenEdges = Object.values(edgesData)
                .filter(e => this.getNode(e.from))
                .filter(e => this.getNode(e.to))

            hiddenNodes = Array.from(new Set([
                ...hiddenNodes,
                ...hiddenEdges
                    .filter(e => hiddenNodes.includes(e.from))
                    .filter(e => (this.getNode(e.to).level > this.getNode(e.from).level))
                    .map(e => e.to),
                ...hiddenEdges
                    .filter(e => hiddenNodes.includes(e.to))
                    .filter(e => (this.getNode(e.from).level > this.getNode(e.to).level))
                    .map(e => e.from)
            ].filter(e => !this.nodesToHide.includes(e) )))

            hiddenEdges = Array.from(new Set([
                ...Object.values(edgesData)
                    .filter(e => hiddenNodes.includes(e.from) || hiddenNodes.includes(e.to))
                    .map(e => e.id)
            ]))

            this.nodes.update(Object.values(nodesData).map(e => ({ ...e, hidden: hiddenNodes.includes(e.id) })))
            this.edges.update(Object.values(edgesData).map(e => ({ ...e, hidden: hiddenEdges.includes(e.id) })))

            if(recursionCounter > 0) {
                this.findAndHideRequsively(hiddenNodes, recursionCounter - 1)
            }
        },
        // NOTE "Поиск всех закрытых нод из легенды"
        findAllHiddenNodesFromLegendStatus() {
            const legendStateNodeGroup = Object.keys(this.legend.nodes).filter(e => !this.legend.nodes[e]).map(Number)
            const legendStateStatus = Object.keys(this.legend.status).filter(e => !this.legend.status[e]).map(Number)
            const legendStateEdge = Object.keys(this.legend.edges).filter(e => !this.legend.edges[e]).map(Number)

            // ноды которые нужно скрыть
            const filterNodeIds = Object.values(this.nodes._data)
                .filter(e => legendStateNodeGroup.includes(e.group) || legendStateStatus.includes(e.status))
                .map(e => e.id)

            const hiddenEdges = Object.values(this.edges._data)
                .filter(e => legendStateEdge.includes(e.type))
            
            const filterNodesFromEdges = Array.from(new Set([
                ...hiddenEdges
                    .filter(e => (this.getNode(e.to).level > this.getNode(e.from).level))
                    .map(e => e.to),
                ...hiddenEdges
                    .filter(e => (this.getNode(e.from).level > this.getNode(e.to).level))
                    .map(e => e.from)
            ]))

            const nodesToHide = Array.from(new Set([...filterNodeIds, ...filterNodesFromEdges, ...this.nodesToHide]))

            return nodesToHide
        },
        getEdgeDashesByType(type) {
            return [4, 6].includes(type)
        },
        getEdgeColorByType(type) {
            return [3, 4].includes(type) ? '#2980b9' : '#cbc7cd'
        }
    },
    computed: {
        relationsNetworkClassNames() {
            return {
                'relations-network': true,
                'relations-network_fullscreen': this.fullscreen
            }
        },
        hintSuggestion() { return this.$store.state.relations.hintSuggestion }
    },
    watch: {
        fullscreen(val) {
            document.body.style.overflow = val ? 'hidden' : 'visible'
        }
    }
}
</script>

<style lang="sass" scoped>
.relations-network
    height: 100%
    position: relative
    background-color: #fff
    &_fullscreen
        position: fixed
        width: 100%
        height: 100vh
        top: 0
        left: 0
        z-index: 123
    .afil-legend.fullscreen
        bottom: 15px
        right: 15px

#relations-search-scheme
    width: 100%
    height: 100%
    min-height: 500px
    // min-width: 500px
    margin: 0 auto
</style>